import "es6-shim";
import "react-app-polyfill/ie11";
import "nodelist-foreach-polyfill";
import * as React from "react";
import * as ReactDOM from "react-dom";
import "library/src/Styles/BaseStyles";
import { App } from "./App";
import { store } from "./Store";
import { Provider } from "react-redux";
import { FontFacesTheinhardt } from "library/src/Styles/Font/Theinhardt/Theinhardt";

window.addEventListener(
    "touchstart",
    function onFirstTouch(): void {
        document.body.classList.add("user__can-touch");
        window.removeEventListener("touchstart", onFirstTouch, false);
    },
    false
);

ReactDOM.render(
    <Provider store={store}>
        <FontFacesTheinhardt />
        <App />
    </Provider>,
    document.getElementById("root")
);
